import React from 'react';

// Custom event to ensure updates propagate instantly
const ROUTE_EVENT = 'route-change';

// Navigate programmatically
export const navigate = (path: string) => {
  const cleanPath = path.startsWith('/') ? path : '/' + path;
  window.history.pushState({}, '', cleanPath);
  
  // Dispatch event for App to listen to
  window.dispatchEvent(new Event(ROUTE_EVENT));
};

interface LinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  to: string;
}

export const Link: React.FC<LinkProps> = ({ to, children, className, onClick, ...props }) => {
  const isExternal = to.startsWith('http') || to.startsWith('mailto:');
  
  // Construct href for accessibility/hover
  const href = isExternal ? to : (to.startsWith('/') ? to : '/' + to);

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (onClick) onClick(e);
    
    // Default browser behavior for external links or modifier keys (Ctrl+Click)
    if (isExternal || e.metaKey || e.ctrlKey) return;
    
    // For internal links, prevent browser default and use our router
    e.preventDefault();
    navigate(to);
  };

  return (
    <a href={href} onClick={handleClick} className={className} {...props}>
      {children}
    </a>
  );
};